import {getEventId, getEventTitle} from '@wix/wix-events-commons-statics'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {getEventDateInformation, isMultiDay} from '../../../../../../../../../commons/selectors/event'
import {useWidgetState} from '../../../../../../hooks/state-provider'
import {getMultiDayText} from '../../../../../../selectors/events'
import s from './event-info.scss'
import {EventInfoProps} from './interfaces'

export const EventInfo = ({event, currentDate}: EventInfoProps) => {
  const {t} = useTranslation()

  const multiDay = useWidgetState(state => isMultiDay(state, event))
  const multiDayTime = useWidgetState(state => getMultiDayText(state, getEventId(event), currentDate, t))
  const firstEventTime = useWidgetState(state => getEventDateInformation(state, getEventId(event))).startTime

  return (
    <div className={classNames(s.eventInfo, {[s.multiDay]: multiDay})}>
      <div className={s.time}>{multiDay ? multiDayTime : firstEventTime}</div>
      <div className={s.title}>{getEventTitle(event)}</div>
    </div>
  )
}
